// extracted by mini-css-extract-plugin
export default {"cookiesWapper":"CookiesFooter_cookiesWapper__LDPbG"};